import { getAuthProps } from "./utils/AuthenticationLibrary.js";
import LayoutNavigation from "./navigation/LayoutNavigation.js";
import ComponentNavigation from "../src/navigation/ComponentNavigation.js";
import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import "./App.css";
// import "./css/additional-styles/theme.scss";

function App() {
  const authDetails = getAuthProps();

  if (window.location.pathname === "/") {
    window.location.href = "/Login";
  } else {
    if (window.location.pathname.toLocaleLowerCase() !== "/login") {
      if (authDetails) {
        ComponentNavigation.forEach(element => {
          element.authDetails = authDetails;
        });
      }
      else {
        switch (window.location.pathname.toLocaleLowerCase()) {
          case "/login":
            window.location.href = "/Login";
            break;
          default:
            window.location.href = "/Login";
        }
      }
    }
  }

  return (
    <>
      <LayoutNavigation
        componentRoutes={ComponentNavigation}
        authDetails={authDetails}
      />
    </>
  );
}

export default App;
